<template>
  <v-container>
    <h1>Backend User Data</h1>
    <br>

    <v-card>
      <v-card-title class="blue">
        <span class="headline white--text">Details</span>
        <v-spacer />
      </v-card-title>

      <v-card-text class="px-0 py-0">
        <v-alert
          v-if="error"
          :value="error"
          type="error"
          color="error"
        >
          {{ error }}
        </v-alert>

        <user-detail-component
          v-if="isLoadUser && isLoadSignings && isLoadTradeAccount && user"
          :user="user"
          :signings="signings"
          :trade-account="tradeAccount"
          :on-change-user="onChangeUser"
        />

        <v-layout
          v-if="!isLoadUser && !isLoadSignings && !isLoadTradeAccount"
          justify-center
        >
          <div class="my-3">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            />
          </div>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { UserDetailComponent } from '@/components/users';

export default {
  name: 'UserDetails',
  components: {
    'user-detail-component': UserDetailComponent,
  },
  data() {
    return {
      user: null,
      signings: [],
      tradeAccount: {},
      upvestAccount: {},
      isLoadUser: false,
      isLoadSignings: false,
      isLoadTradeAccount: false,
      error: null,
    };
  },
  async mounted() {
    this.isLoadUser = false;
    try {
      this.user = await this.getUserById(this.$route.params.id);
      this.isLoadUser = true;
    } catch (error) {
      this.user = null;
      this.error = `Error getting user info ${this.$route.params.id}`;
      this.isLoadUser = true;
    }

    this.isLoadSignings = false;
    try {
      this.signings = await this.getUserSigningsById(this.$route.params.id);
      this.isLoadSignings = true;
    } catch (error) {
      this.signings = [];
      this.isLoadSignings = true;
    }

    this.isLoadTradeAccount = false;
    try {
      this.tradeAccount = await this.getAccountByUserId(this.$route.params.id);
      this.isLoadTradeAccount = true;
    } catch (error) {
      this.tradeAccount = {};
      this.isLoadTradeAccount = true;
    }

    this.isLoadUpvestAccount = false;
    try {
      this.isLoadUpvestAccount = true;
    } catch (error) {
      this.upvestAccount = {};
      this.isLoadUpvestAccount = true;
    }
  },
  methods: {
    ...mapActions([
      'getUserById',
      'getUserSigningsById',
      'getAccountByUserId',
    ]),
    async onChangeUser(data) {
      this.user[data.name] = data.value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/users/UserDetail.vue